var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toast-container"},_vm._l((_setup.state.items),function(item){return _c(_setup.ToastComponent,{key:item.id,attrs:{"type":item.type,"title":item.title,"message":item.message,"duration":item.duration},on:{"close":function($event){return _setup.removeToast(item.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }